import { ConfigType } from "../context/ConfigContext";
import {
  UPDATE_CASHPICKUP,
  UPDATE_CONFIG,
  UPDATE_PURPOSE_OF_TRANSFER,
  UPDATE_SOURCE_OF_INCOME,
  UPDATE_TELCOS,
} from "../types/config.type";

const ConfigReducer = (state: ConfigType, action: any) => {
  switch (action.type) {
    case UPDATE_CONFIG:
      return action.payload;
    case UPDATE_PURPOSE_OF_TRANSFER:
      return {
        ...state,
        purposeOfTransfer: action.payload,
      };
    case UPDATE_SOURCE_OF_INCOME:
      return {
        ...state,
        sourceOfIncome: action.payload,
      };
    case UPDATE_CASHPICKUP:
      return {
        ...state,
        cashPickUpBanks: action.payload,
      };
    case UPDATE_TELCOS:
      return {
        ...state,
        telcos: action.payload,
      };
    default:
      return state;
  }
};
export default ConfigReducer;
